import { useCallback, useRef } from 'react';

export function useDialog() {
    const dialogRef = useRef<HTMLDialogElement>(null);

    const openDialogRef = useCallback(() => {
        if (dialogRef.current && !dialogRef.current.open) {
            dialogRef.current.showModal();
        }
    }, []);

    const closeDialogRef = useCallback((): Promise<void> => {
        return new Promise((resolve) => {
            const dlg = dialogRef.current;
            if (!dlg) return resolve();

            const handleClose = () => {
                dlg.removeEventListener('close', handleClose);
                resolve();
            };

            dlg.addEventListener('close', handleClose, { once: true });

            if (dlg.open) {
                dlg.close();
            } else {
                resolve();
            }
        });
    }, []);

    return { dialogRef, openDialogRef, closeDialogRef };
}
